module.exports = __webpack_public_path__ + "img/Daily_login.0e5a91fa.png";